import { useEffect, useRef, useState } from '@wordpress/element';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { SelectItemOptionsType } from 'primereact/selectitem';
import { publish } from '@media-store-net/custom-events';

interface OptionType {
	[ key: string ]: string;
}

interface SortByFieldProps {
	label?: string;
	options: OptionType;
	id?: string;
	className?: string;
	name?: string;
	selectedValue?: string;
}

const SortByField = ( props: SortByFieldProps ) => {
	const { label, selectedValue, options, id, className, ...restProps } =
		props;

	useEffect( () => {
		if ( ! options ) {
			console.warn( 'SortByField: Options are required' );
			return;
		}

		if ( ! label || typeof label !== 'string' ) {
			console.warn( 'SortByField: Label prop must be a string' );
			return null;
		}

		setActiveSortField( selectedValue ?? 'ID_desc' );
		const _sortOptions = Object.keys( options ).map( ( key: string ) => {
			return {
				value: key,
				label: options[ key ],
			};
		} ); // map object to array
		setSortOptions( _sortOptions );
	}, [ props ] );

	const [ activeSortField, setActiveSortField ] =
		useState< SortByFieldProps[ 'selectedValue' ] >( '' );
	const [ sortOptions, setSortOptions ] = useState<
		SelectItemOptionsType | []
	>( [] );
	const sortFieldRef = useRef< HTMLDivElement >( null );

	const onSelectChangedHandler = ( e: DropdownChangeEvent ) => {
		setActiveSortField( e.value );
		publish( 'sortByFieldChanged', {
			fieldRef: sortFieldRef.current,
			selectedValue: e.value,
		} );
	};

	return (
		<div
			ref={ sortFieldRef }
			className={ `sort-by-bar col-xs-12 ${ className ?? '' }` }
		>
			<div className="form-group">
				<label htmlFor={ id }>{ label ?? '' }</label>
				<Dropdown
					id={ id }
					options={ sortOptions }
					value={ activeSortField }
					optionValue="value"
					onChange={ onSelectChangedHandler }
					{ ...restProps }
				/>
			</div>
		</div>
	);
};

export default SortByField;
